import {images} from './images'
import {CategoryDetails, Category, MetaTagsProps} from "@/types";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
    Camera,
    Video,
    Palette,
} from 'lucide-react';
import {category as service1, createMetaTags as tags1} from "./1";
import {category as service2, createMetaTags as tags2} from "./2";
import {category as service3, createMetaTags as tags3} from "./3";
import {category as service4, createMetaTags as tags4} from "./4";
import {category as service5, createMetaTags as tags5} from "./5";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";


const slug = 'smart-solar-renewable-energy-sydney';
const categoryId = 1
export const headCategory: Category = {
    id: 1,
    key: 'solar',
    name: 'Smart Solar & Renewable Energy Sydney',
    long_name: 'Smart Solar & Renewable Energy Sydney',
    slug,
    categoryType: 'services',
}

export const metaTags: MetaTagsProps = {
    title: `Smart Solar & Renewable Energy Sydney | ${BUSINESS_NAME}`,
    description: "Cut your power bills and embrace clean energy with our expert solar installations, battery storage, and maintenance services designed for Sydney’s unique conditions.",
    keywords: "smart solar Sydney, renewable energy solutions, solar panel installation, battery storage systems, solar maintenance services, clean energy Sydney, residential solar solutions, commercial solar installations, energy efficiency Sydney, solar power experts",
    url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}`,
    ogImage: `${OG_PATH}c${categoryId}.jpg`,
    type: "website",
}
export const subCategoryObject = Object.fromEntries(
    Object.entries({
        category1Service1: {...service1, ...tags1(metaTags)},
        category1Service2: {...service2, ...tags2(metaTags)},
        category1Service3: {...service3, ...tags3(metaTags)},
        category1Service4: {...service4, ...tags4(metaTags)},
        category1Service5: {...service5, ...tags5(metaTags)}
    }).map(([key, value]) => [key, {...value, headCategory}])
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
    ...headCategory,
    metaTags,
    order: 1,
    icon: <EmojiEventsIcon/>,
    description: ['Cut your power bills and embrace clean energy with our expert solar installations, battery storage, and maintenance services designed for Sydney’s unique conditions.'],
    points: [
        {
            title: '',
            icon: Camera,
        },
        {
            title: '',
            icon: Video,
        },
        {
            title: '',
            icon: Palette,
        },
    ],
    videos: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    subCategories,
}
